<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar moneda' : 'Nueva moneda' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- Clave -->
          <div class="mod-field">
            <label for="Clave">Clave <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Clave"
              v-model="form.Clave"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Codigo de la moneda"
            >
          </div>

          <!-- Nombre -->
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Nombre"
              v-model="form.Nombre"
              required
              placeholder="Nombre de la moneda"
            >
          </div>

          <!-- Simbolo -->
          <div class="mod-field">
            <label for="Simbolo">Simbolo</label>
            <input
              type="text"
              id="Simbolo"
              v-model="form.Simbolo"
              placeholder="Ej: $, €, £"
            >
          </div>

          <!-- Decimales -->
          <div class="mod-field">
            <label for="Decimales">Decimales</label>
            <input
              type="number"
              id="Decimales"
              v-model.number="form.Decimales"
              placeholder="2"
            >
          </div>

          <!-- Clave2 -->
          <div class="mod-field">
            <label for="Clave2">Clave 2</label>
            <input
              type="text"
              id="Clave2"
              v-model="form.Clave2"
              placeholder="Clave alternativa"
            >
          </div>

          <!-- Clave3 -->
          <div class="mod-field">
            <label for="Clave3">Clave 3</label>
            <input
              type="text"
              id="Clave3"
              v-model="form.Clave3"
              placeholder="Clave alternativa"
            >
          </div>

          <!-- ClaveErp -->
          <div class="mod-field">
            <label for="ClaveErp">Clave ERP</label>
            <input
              type="text"
              id="ClaveErp"
              v-model="form.ClaveErp"
              placeholder="Mapeo con sistema ERP"
            >
          </div>

          <!-- Orden -->
          <div class="mod-field">
            <label for="Orden">Orden</label>
            <input
              type="number"
              id="Orden"
              v-model.number="form.Orden"
              placeholder="0"
            >
          </div>

          <!-- Notas -->
          <div class="mod-field">
            <label for="Notas">Notas</label>
            <input
              type="text"
              id="Notas"
              v-model="form.Notas"
              placeholder="Notas adicionales"
            >
          </div>

          <!-- EsActivo -->
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear moneda' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import monedaService from './moneda.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createMoneda } from './moneda.model';

export default {
  name: 'MonedaForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createMoneda(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.Clave || !this.form.Nombre) {
        this.error = 'Clave y Nombre son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await monedaService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
